module.exports = __webpack_public_path__ + "static/1-3ca6ce6ff7fd342eaf99ca1cf064b730.jpg";